import React, { useState } from "react";
import { Navbar } from "reactstrap";
import { Link, Redirect } from "react-router-dom";
import Logo from "../../atoms/logo";
import AvatarMenu from "../../molecules/avatarMenu";
import { GET_USER_EMAIL } from "../../../constants";

const Header = (props) => {
  // const [isOpen, setIsOpen] = useState(false);
  const [redirect, setRedirect] = useState(null);

  // const toggle = () => setIsOpen(!isOpen);
  const logout = () => setRedirect("/login");

  const userEmail = GET_USER_EMAIL();

  if (redirect) return <Redirect to={redirect} />;
  return (
    <div>
      <Navbar
        color="white"
        expand="md"
        className="box-shadow-bottom sticky-top"
      >
        <Link to="/projects" className="navbar-brand">
          <Logo />
        </Link>
        <AvatarMenu email={userEmail} logout={logout} />
      </Navbar>
    </div>
  );
};

export default Header;
